/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './live-video-right-rail.stache';
import can from 'can';
import dtm from 'scripts/services/dtm';

Component.extend({
    tag: 'video-right-rail',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            player: {
                type: 'object',
            },
            activeChannels: {
                Type: can.List,
                Value: can.List,
            },
            activeView: {
                type: 'object',
                value: null,
            },
            products: {
                Type: can.Map,
                Value: null,
            },
            productsCtaLink: {
                Type: can.Map,
                Value: null,
            },
            highlightEnded: {
                type: 'number',
            },
            favToggledKey: {
                type: 'number',
            },
        },
        activeTab: 'channels',
        onDataLoaded() {
            this.dispatch('dataLoaded');
        },
        favToggled() {
            this.attr('favToggledKey', Math.random());
        },
        activeTabChange(__, ___, { payload: tab }) {
            this.attr('activeTab', tab);
        },
    },
    events: {
        '.s-video-right-rail-tabs__item click'(element) {
            const tab = $(element).data('tab');

            if (
                !$(element).hasClass('is-selected') &&
                !$(element).hasClass('is-disabled')
            ) {
                this.viewModel.attr('activeTab', tab);
            }

            dtm.trackWatchLiveRightRailTabClick(tab);
        },
    },
});
